module.exports = __webpack_public_path__ + "assets/fe7626afb07f72d5ae5105b06e92eeb5.png";